export default __webpack_public_path__ + "static/knz-74c7e32aea007c6d48c4523b8f43a9e1.png";